import React from "react";
import {getStateFromSelector} from "../../redux/store";
import {CURRENT_SESSION_STATE_REDUCER} from "../../redux/reducers";
const SideBar = () => {
    const {pageTitle} = getStateFromSelector(CURRENT_SESSION_STATE_REDUCER)
    return (
        <div className="d-flex flex-column">
            <div className="profile">
                <img src={require('../../asserts/icons/logo-white.png')} alt=""  style={{ width:'50%', borderRadius:"100%"}} />
                <h1 className="text-light"><a href="#">{pageTitle}</a></h1>
                <div className="social-links mt-3 text-center">
                    <a href="https://twitter.com/structlooper" target="_blank" className="twitter"><i className="bx bxl-twitter"/></a>
                    <a href="https://www.facebook.com/structlooper" target="_blank" className="facebook"><i className="bx bxl-facebook"/></a>
                    <a href="https://www.instagram.com/structlooper/" target="_blank" className="instagram"><i className="bx bxl-instagram"/></a>
                    {/*<a href="#" className="google-plus"><i className="bx bxl-skype"></i></a>*/}
                    <a href="https://www.linkedin.com/in/structlooper" target="_blank" className="linkedin"><i className="bx bxl-linkedin"/></a>
                </div>
            </div>

            <nav id="navbar" className="nav-menu navbar">
                <ul>
                    <li><a href="#hero" className="nav-link scrollto active"><i className="bx bx-home"/>
                        <span>Home</span></a></li>
                    <li><a href="#about" className="nav-link scrollto"><i className="bx bx-user"/> <span>About</span></a>
                    </li>
                    <li><a href="#resume" className="nav-link scrollto"><i className="bx bx-file-blank"/>
                        <span>Resume</span></a></li>
                    {/*<li><a href="#portfolio" className="nav-link scrollto"><i className="bx bx-book-content"></i>*/}
                    {/*    <span>Portfolio</span></a></li>*/}
                    <li><a href="#projects" className="nav-link scrollto"><i className="bx bx-server" />
                        <span>Projects</span></a></li>
                    <li><a href="#contact" className="nav-link scrollto"><i className="bx bx-envelope"/>
                        <span>Contact</span></a></li>
                </ul>
            </nav>
        </div>
    );
}

export default SideBar;